import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginDoctor, clearError } from '../redux/slices/authSlice';
import { useNavigate } from 'react-router-dom';
import '../styles/Auth.css';

const DoctorLoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      dispatch(clearError());
      alert('Please fill in all fields');
      return;
    }

    const result = await dispatch(loginDoctor(formData));
    if (result.payload && result.payload.token) {
      navigate('/dashboard');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">Doctor Login</h1>
        <p className="auth-subtitle">Welcome to Healthcare Management System</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
              disabled={loading}
            />
          </div>

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="auth-logo">
          <img src="/images/doctaura_logo.png" alt="Doctaura Logo" />
        </div>

        {/* <div className="auth-links">
          <a href="/forgot-password" className="auth-link">
            Forgot Password?
          </a>
          <span className="auth-divider">|</span>
          <a href="/register" className="auth-link">
            Register as Doctor
          </a>
          <span className="auth-divider">|</span>
          <a href="/admin/login" className="auth-link">
            Admin Login
          </a>
        </div> */}

        {/* <div className="auth-footer">
          <p>Don't have an account? <a href="/register">Create one now</a></p>
        </div> */}

        {/* Privacy Policy Footer */}
        <div className="privacy-footer-link">
          <p className="privacy-text">
            By logging in, you agree to our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DoctorLoginPage;
